'use client';

import { createContext, useContext, type ReactNode } from 'react';

interface CurrentUserContextValue {
  // Reserved for future cross-hook coordination. Server state lives in React Query.
}

const CurrentUserContext = createContext<CurrentUserContextValue | null>(null);

export function CurrentUserProvider({ children }: { children: ReactNode }) {
  return <CurrentUserContext.Provider value={{}}>{children}</CurrentUserContext.Provider>;
}

export function useCurrentUserContext(): CurrentUserContextValue {
  const ctx = useContext(CurrentUserContext);
  if (!ctx) throw new Error('CurrentUserProvider not mounted');
  return ctx;
}
